<template>
    <!-- center col START -->
    <div class="centerCol center-8col"><!-- class center-8col когда в центральном блоке 12 колонок -->

      <!-- row-th6-top start -->
      <div class="row-th6-top">
        <div class="th" @click="$router.push({name: 'MainTab'})">{{$t('main')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: 'OverUnder'})">{{$t('ov/un')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: 'HomeOVUN'})">{{$t('homeovun')}}</div><!-- +/- class lightgreen -->
        <div class="th lightgreen" @click="$router.push({name: 'AwayOVUN'})">{{$t('awayovun')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: '1X2OVUN1'})">{{$t('1x2ovun')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: '1X2OVUN2'})">{{$t('1x2ovun2')}}</div><!-- +/- class lightgreen -->
      </div>
      <!-- row-th6-top stop -->

      <!-- row-th8-continuous start -->
      <div class="row-th8-continuous">
        <div class="th">{{$t('ov')}}0.5</div>
        <div class="th">{{$t('un')}}0.5</div>
        <div class="th">{{$t('ov')}}1.5</div>
        <div class="th">{{$t('un')}}1.5</div>
        <div class="th">{{$t('ov')}}2.5</div>
        <div class="th">{{$t('un')}}2.5</div>
        <div class="th">{{$t('ov')}}3.5</div>
        <div class="th">{{$t('un')}}3.5</div>
      </div>
      <!-- row-th8-continuous stop -->

      <!-- td-center-block start -->
      <div class="td-center-block">

        <!-- row-td8 start -->
        <div class="row-block row-td8" v-for="item in $store.state.game.Match">
          <div class="row-conainer">
            <div class="td" :class="classchange(item, 'AwayOver(0.5)')" @click="addbet('AwayOver(0.5)', item.Odds['AwayOver(0.5)'], item)">{{item.Odds['AwayOver(0.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayUnder(0.5)')" @click="addbet('AwayUnder(0.5)', item.Odds['AwayUnder(0.5)'], item)">{{item.Odds['AwayUnder(0.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayOver(1.5)')" @click="addbet('AwayOver(1.5)', item.Odds['AwayOver(1.5)'], item)">{{item.Odds['AwayOver(1.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayUnder(1.5)')" @click="addbet('AwayUnder(1.5)', item.Odds['AwayUnder(1.5)'], item)">{{item.Odds['AwayUnder(1.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayOver(2.5)')" @click="addbet('AwayOver(2.5)', item.Odds['AwayOver(2.5)'], item)">{{item.Odds['AwayOver(2.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayUnder(2.5)')" @click="addbet('AwayUnder(2.5)', item.Odds['AwayUnder(2.5)'], item)">{{item.Odds['AwayUnder(2.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayOver(3.5)')" @click="addbet('AwayOver(3.5)', item.Odds['AwayOver(3.5)'], item)">{{item.Odds['AwayOver(3.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td" :class="classchange(item, 'AwayUnder(3.5)')" @click="addbet('AwayUnder(3.5)', item.Odds['AwayUnder(3.5)'], item)">{{item.Odds['AwayUnder(3.5)']}}</div><!-- +/- class bordeaux -->
          </div>
        </div>
        <!-- row-td8 stop -->
          
      </div>
      <!-- td-center-block stop -->

    </div>
    <!-- center col STOP -->
</template>

<script>
import Vue from 'vue'
import Cookies from 'js-cookie'

export default {
  name: 'Football',
    created() {

  },
  methods: {
    addbet(name, price, game){
      let bet = {
        GameID: this.$store.state.game.GameID,
        MatchID: game.MatchID,
        HomeTeam: game.HomeTeam,
        AwayTeam: game.AwayTeam,
        Bet: name,
        Price: price,     
        Amount: 0,
      }
      if(this.$store.state.Bets.some(elem => elem.MatchID === bet.MatchID && elem.Bet === bet.Bet)){
        let i = this.$store.state.Bets.findIndex((element) => element.MatchID == bet.MatchID && element.Bet == bet.Bet);
        return this.$store.state.Bets.splice(i, 1);
      }else if(this.$store.state.Bets.some(elem => elem.MatchID === bet.MatchID)){
        return
      }else{
        return this.$store.dispatch('addbet', {bet: bet});
      }
    },
    classchange(match, bet){
      if(this.$store.state.Bets == null) return
      if(this.$store.state.Bets.find( function(item){
        if(item.MatchID == match.MatchID) {
          if(item.Bet == bet) return true }
      })) return 'bordeaux'
    }
  },
  data: ()=>{
    return {
      btnclass: ''
    }
  }
  
};
</script>